import React from 'react';
import MarkDown from '@/components/Documents/docs/MarkDown';

const md = `
# 方案介绍

基于开放平台 Darts 鉴权开发，实现 公司业务方 -> 第三方业务方 通用化请求参数透传，并实现异步消息自动存入 ons 机制。
`;

export default function () {
  return (
    <MarkDown docs={md}></MarkDown>
  )
}
